import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ListItem from '@material-ui/core/ListItem';
import Link from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import ButtonBase from '@material-ui/core/ButtonBase';
import opportunityimg from '../../../../assets/Opportunity_Dashboard.png';
import leadimg from '../../../../assets/Lead_Dashboard.png';
import salesimg from '../../../../assets/Sales_Dashboard.png';
import supportimg from '../../../../assets/Support_Dashboard.png';
import customimg from '../../../../assets/plusicon.png';
import { Skeleton } from '../../../../components';
import { toast } from "react-toastify";


import { none } from 'ramda';



import { addDashboard,addDashboardLoading } from "../../../../store/actions/dashboard.actions";
import Scrollbars from 'react-custom-scrollbars';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    centerSpan: {
        textAlign: 'center',
        paddingTop: 2,
    },
    borderCustom: {
        border: 'solid 2px blue',
    },
    borderNone: {
        border: none,
    },
    image: {
        height: 200,
    },
    cImage: {
        height: 200,
        marginLeft: '20%',
        marginRight: '20%',
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    RightSubmit: {
       // float: 'right',
    },
    spaceCadd: {
        marginRight: 2,
    },
    dashletLink: {
        textDecoration: 'none !important'
    },
    whitetextcolor:{
        color:'#ffffff',
    }
}));

export default function AddTab({ setAddedDashboard, openAddTab, setOpenAddTab }) {
    // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });
    const { addDashboardLoading } = useSelector((state) => state.dashboard);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [openC, setOpenC] = useState(false);
    const [currentSel, setCurrentSel] = useState('');
    const [parentMenuName, setParentMenuName] = useState('');
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [value, setValue] = useState(null);
    const handleClickOpen = () => {
        setOpenAddTab(true);
    };
    const handleClickOpenC = () => {
        setOpenC(true);
    };
    const handleCloseC = () => {
        setValue('');
        setCurrentSel('Custom');
        setOpenC(false);
    };
    const handleClose = () => {
        setOpenAddTab(false);
    };
    const handleChange = (event) => {
        setValue(event.target.value);
        setCurrentSel(event.target.value);
    };
    const handleChangeParentMenuName = (event) => {
        setParentMenuName(event.target.value);
    };
    const submitForm = (e) => {
        e.preventDefault();
        addDashboardTab(currentSel)
    };
    const submitFormC = (e) => {
        e.preventDefault();
        addDashboardTab(currentSel,parentMenuName)

    };
    const setCurrentSelC = (name) => {
        setCurrentSel(name);
    };
    const setCurrentSelCustom = (name) => {
        setCurrentSelC(name);
        handleClickOpenC();
    };


    const addDashboardTab = (dashName,pName='') => {
        try {
            dispatch(addDashboard(dashName,pName)).then(function (res) {
                if (res) {
                    if (res.status === 200) {
                        // setToast({ toastVisible: true, toastMessage: "Dashboard Added Successfully!" });
                        setAddedDashboard(res.data.data.data.current_tab)
                        setOpenC(false);
                        setOpenAddTab(false);

                    } else {
                        toast("Duplicate dashboard name!");
                    }
                } else {
                    toast('Something went wrong!');
                }
            });
        } catch (e) {
            toast('Something went wrong!');
        }

    }

    const classes = useStyles();
    return (
        <div>
            {/* <Link onClick={handleClickOpen} className={classes.spaceCadd}>
                <DashboardIcon />
            </Link> */}
            <Dialog
                fullWidth={true}
                maxWidth="md"
                open={openAddTab}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <form name="adddashboard">
                <DialogTitle id="responsive-dialog-title">Add Dashboard Page</DialogTitle>
                
                <DialogContent style={{overflowX:"hidden"}}>
                    <Scrollbars  autoHide={true} style={{height:"60vh"}}>
                    
                        <div className={classes.root}>
                            <Grid container justify="space-between" spacing={3}>
                                {/*<Grid item xs={3} sm={3}>

                                    <Paper className={classes.paper, currentSel == 'Opportunities Dashboard' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelC('Opportunities Dashboard')} className={classes.image}>
                                            <img className={classes.img} alt="complex" src={opportunityimg} />
                                        </ButtonBase>

                                    </Paper>
                                    <div className={classes.centerSpan} >
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Opportunity Dashboard</Link>} />
                                    </div>

                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Leads Dashboard' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelC('Leads Dashboard')} className={classes.image}>
                                            <img className={classes.img} alt="complex" src={leadimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Lead Dashboard</Link>} />
                                    </div>
                            </Grid>*/}
                            <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Support Dashboard' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelC('Support Dashboard')} className={classes.image}>
                                            <img className={classes.img} alt="complex" src={supportimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Support Dashboard</Link>} />
                                    </div>
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Sales Dashboard' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelC('Sales Dashboard')} className={classes.image}>
                                            <img className={classes.img} alt="complex" src={salesimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Sales Dashboard</Link>} />
                                    </div>
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Custom' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelCustom('Custom')} className={classes.cImage}>
                                            <img className={classes.img} alt="complex" src={customimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Custom</Link>} />
                                    </div>
                                </Grid>
                            </Grid>
                            {/*<Grid container justify="space-between" spacing={3}>
                                <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Support Dashboard' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelC('Support Dashboard')} className={classes.image}>
                                            <img className={classes.img} alt="complex" src={supportimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Support Dashboard</Link>} />
                                    </div>
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    <Paper className={classes.paper, currentSel == 'Custom' ? classes.borderCustom : ''}>
                                        <ButtonBase onClick={() => setCurrentSelCustom('Custom')} className={classes.cImage}>
                                            <img className={classes.img} alt="complex" src={customimg} />
                                        </ButtonBase>
                                    </Paper>
                                    <div className={classes.centerSpan}>
                                        <ListItemText
                                            primary={<Link className={classes.dashletLink}
                                            >Custom</Link>} />
                                    </div>
                                </Grid>
                                <Grid item xs={3}>
                                    <div style={{ display: 'none' }}>

                                    </div>
                                </Grid>
                            </Grid>*/}
                        </div>
                        </Scrollbars>
                </DialogContent>
                
                <DialogActions>
                    {(currentSel != 'Custom') ?
                    <Button className={classes.whitetextcolor} variant="contained" size="small" color="primary" disabled={!currentSel} type='submit' onClick={submitForm}>Submit</Button> : ' '}
                    <Button className={classes.whitetextcolor} autoFocus variant="contained" size="small" onClick={handleClose} color="primary">Close</Button>
                </DialogActions>
                </form>
                </Dialog>
                <Dialog
                    open={openC}
                    onClose={handleCloseC}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Add Custom Dashboard</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <form name="adddashboardC" >
                                <div className={classes.root}>
                                    <TextField
                                        id="dashName"
                                        label="Enter Dashboard Name:"
                                        style={{ margin: 8 }}
                                        placeholder="Dashboard Name..."
                                        helperText=""
                                        fullWidth
                                        margin="normal"
                                        value={value} onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />

                                </div>
                                <div className={classes.root}>
                                    <TextField
                                        id="dashParentNenuName"
                                        label="Enter Parent Menu:"
                                        style={{ margin: 8 }}
                                        placeholder="Parent Menu Name..."
                                        helperText=""
                                        fullWidth
                                        margin="normal"
                                        value={parentMenuName} onChange={handleChangeParentMenuName}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />

                                </div>
                                <div className={classes.RightSubmit}>
                                    
                                </div>
                            </form>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {   addDashboardLoading ?
                                <Button className={classes.whitetextcolor} variant="contained" size="small" color="primary" disabled={!value} type='submit'>
                                    Adding <CircularProgress size={14} style={{ marginLeft: 10, color:"White" }} />
                                </Button>
                            :
                                <Button className={classes.whitetextcolor} variant="contained" size="small" color="primary" disabled={!value} type='submit' onClick={submitFormC}>Submit</Button>
                        }
                        <Button className={classes.whitetextcolor} variant="contained" size="small" autoFocus onClick={handleCloseC} color="primary">Close</Button>
                    </DialogActions>
                    
                </Dialog>
    </div>
    );
}
